import React from 'react';
import { TextField } from 'framework/ui/field';
import { ENGLISH_LEVEL_OPTIONS } from 'domain/recruiting/newVacancy/show/publications/createupdate/VacancyPublicationForm';

interface Props {
  value?: string;
  source?: string;
}

const PublicationsEnglishLevelTextField = ({ value, source }: Props) => {
  const displayValue = ENGLISH_LEVEL_OPTIONS[value as keyof typeof ENGLISH_LEVEL_OPTIONS] || value;

  return <TextField label="" value={displayValue} />;
};

export default PublicationsEnglishLevelTextField;
